import { memo, useMemo, useState } from 'react'
import { Button, ClickAwayListener, Divider, Grid, IconButton, Menu, Typography } from '@material-ui/core'
import { Close, FilterList } from '@material-ui/icons'

import { useStyles } from './styles'

const UserLogList = ({ records = [], addedItemColor, title, buttonTitle = 'ROLES', children, diffProp = 'new' }) => {
   const [anchorEl, setAnchorEl] = useState()
   const isSomeNewRecord = useMemo(() => records?.some(record => record?.[diffProp]), [records])
   const classes = useStyles({ isSomeNewRecord, addedItemColor })

   const handleOpen = e => {
      setAnchorEl(prev => (prev ? null : e.currentTarget))
   }

   return (
      <ClickAwayListener onClickAway={handleOpen}>
         <>
            <Button onClick={handleOpen} className={classes.button}>
               <Typography>{buttonTitle}</Typography> <FilterList />
            </Button>
            <Menu
               className={classes.menu}
               open={Boolean(anchorEl)}
               anchorEl={anchorEl}
               anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
               transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
               <Grid container direction="column">
                  <Grid container className={classes.menuHeader}>
                     <Typography>{title}</Typography>
                     <IconButton onClick={handleOpen} size="small">
                        <Close color="primary" />
                     </IconButton>
                  </Grid>
                  <Divider />
                  <Grid container direction="column" className={classes.menuContent}>
                     {children}
                  </Grid>
               </Grid>
            </Menu>
         </>
      </ClickAwayListener>
   )
}

export default memo(UserLogList)
